import { useFormikContext, useField } from 'formik';
import identity from 'lodash.identity';
import startCase from 'lodash.startcase';

const useFormHelpers = (props, {
  getValue = identity
} = {}) => {
  const {
    isSubmitting
  } = useFormikContext();
  const [{
    name,
    onBlur,
    onChange,
    value
  }, {
    touched,
    error: errorMessage
  }] = useField(props);
  const isError = !!errorMessage;
  const showError = props.showErrorBeforeTouched ? isError : touched && isError;
  return {
    disabled: isSubmitting,
    error: showError,
    name,
    label: startCase(name),
    onBlur,
    onChange: value => {
      var _getValue;

      return onChange({
        target: {
          name,
          value: (_getValue = getValue(value)) !== null && _getValue !== void 0 ? _getValue : ''
        }
      });
    },
    value,
    ...props,
    helperText: showError ? errorMessage : props.helperText
  };
};

export default useFormHelpers;